export default "__VITE_ASSET__Kq$vYCht__"